import { useRef, useCallback } from 'react';
import useEventListener from '../useEventListener/9f09366b7da3b764593ebdba2da944f43f5b80c36aad677b1adbc5d008d6451c.cfe-internal.js';

/* eslint-disable consistent-return */
/**
 * Listens for `click` event. The returned function is used to ignore the given `click` event.
 * @param onClickOutside - An observer that is called when an outside click occurs.
 * @param options.disabled - Indicates if the hook is disabled (i.e. won't call the observer)
 * @returns A function that, when called, ignores the current outside click if one exists.
 */

function useClickOutsidePortals(onClickOutside) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled;

  var wasClickedInside = useRef(false);

  var handleClick = function handleClick(e) {
    if (!wasClickedInside.current) {
      onClickOutside(e);
    } // should reset clicked state after each click


    wasClickedInside.current = false;
  };

  useEventListener(document, 'mouseup', handleClick, {
    isDisabled: disabled
  });
  var preventClickOutside = useCallback(function () {
    wasClickedInside.current = true;
  }, []);
  return preventClickOutside;
}

export { useClickOutsidePortals as default };
